var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96094 1.66406L8.57812 4.19531C8.8125 4.57031 9.30469 4.66406 9.65625 4.38281L11.0391 3.35156C10.9453 3.1875 10.875 3 10.875 2.8125C10.875 2.29688 11.2969 1.875 11.8125 1.875C12.3281 1.875 12.75 2.29688 12.75 2.8125C12.75 3.32812 12.3516 3.75 11.8359 3.75L11.0625 8.85938C10.9688 9.58594 10.3359 10.125 9.58594 10.125H3.16406C2.41406 10.125 1.80469 9.58594 1.6875 8.85938L0.914062 3.75C0.421875 3.75 0 3.32812 0 2.8125C0 2.29688 0.421875 1.875 0.9375 1.875C1.45312 1.875 1.875 2.29688 1.875 2.8125C1.875 3 1.80469 3.1875 1.71094 3.35156L3.09375 4.38281C3.44531 4.64062 3.96094 4.57031 4.19531 4.19531L5.78906 1.66406C5.57812 1.5 5.4375 1.24219 5.4375 0.9375C5.4375 0.421875 5.85938 0 6.375 0C6.89062 0 7.3125 0.421875 7.3125 0.9375C7.3125 1.24219 7.17188 1.5 6.96094 1.66406Z",
    fill: "#D69E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.5b90464295828f20282131d3cebc3915.svg";
export { ForwardRef as ReactComponent };